import React, {useEffect} from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';

import ItemBanner from "../ItemBanner";

const Banner = () => {
    const [showArticles, setShowArticles] = React.useState(false);
    const [articulosBanner, setArticulosBanner] = React.useState(null);

    const verArticulosSlide = () => {
        setShowArticles(!showArticles);
    }

    

    useEffect(() => {    
        const agregarArticulosBanner = (artsBanner) => {
            setArticulosBanner(artsBanner.sort(()=> Math.random() - 0.5));
        }

        const articulosBannerTemp = [
            {
                name: "Audi Junior quattro Kids red",
                id: "a28",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/3201810010.jpeg"
            },{
                name: "quattro flip flop, grey",
                id: "ab7",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/3291800001.jpeg"
            },{
                name: "Audi mug A1 Naranja",
                id: "a34",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/6291900400.jpeg"
            },{
                name: "Audi Sport Motorsport Bear Comforter",
                id: "b1e",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/3201900800.jpeg"
            },{
                name: "Unisex rain jacket, Audi Sport, red",
                id: "b99",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/3131400800.jpeg"
            },{
                name: "Kids TShirt, Audi Sport, white",
                id: "b7a",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/3201500605.jpeg"
            },{
                name: "Audi Sport Pyjama Racing Infants white/red",
                id: "b44",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/3201900504.jpeg"
            },{
                name: "Audi Sport Quilted vest, Mens, black",
                id: "b48",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/3131801802.jpeg"
            },{
                name: "Mens poloshirt, Audi Sport, white",
                id: "b96",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/3131603006.jpeg"
            },{
                name: "Mens lightweight jacket, Audi Sport",
                id: "b8b",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/3131500802.jpeg"
            }
        ];
        agregarArticulosBanner(articulosBannerTemp);
    }, []);

    return (
        <div className="banner">
            <div className={ !showArticles ? "banner__info active" : "banner__info banner__slide" }>
                <div className="banner__info--image d-block d-sm-none col-md-7 col-lg-8">
                    <LazyLoadImage
                        alt="banner01"
                        src="https://www.appsaudi.com.mx/resources/images/boutique/banner/audi_collection_home_principal_mujer_ropa_elegante_y_casual_con_estilo_movil.jpg"
                    />
                </div>
                <div className="banner__info--image d-none d-sm-block col-md-7 col-lg-8">
                    <LazyLoadImage
                        alt="banner01"
                        src="https://www.appsaudi.com.mx/resources/images/boutique/banner/audi_collection_home_principal_mujer_ropa_elegante_y_casual_con_estilo_escritorio.jpg"
                    />
                </div>
                <div className="banner__info--detail col-md-5 col-lg-4">
                    <h3>Comparte todo el estilo</h3>
                    <span>Confía en el estilo Audi</span>
                    <p>Descubre la gama de Audi Collection y refleja tu confianza con artículos exclusivos</p>
                    <button onClick={() => verArticulosSlide()}>Ver</button>
                </div>
            </div>
            <div className={ showArticles ? "banner__articles active" : "banner__articles banner__slide" }>
                
                <div className="banner__articles--all">
                    <div className="d-block container_item">
                        {
                            articulosBanner !== null &&
                            <>
                                <ItemBanner 
                                    name={articulosBanner[0].name}
                                    idArticulo={articulosBanner[0].id}
                                    imagen={articulosBanner[0].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[1].name}
                                    idArticulo={articulosBanner[1].id}
                                    imagen={articulosBanner[1].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[2].name}
                                    idArticulo={articulosBanner[2].id}
                                    imagen={articulosBanner[2].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[3].name}
                                    idArticulo={articulosBanner[3].id}
                                    imagen={articulosBanner[3].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[4].name}
                                    idArticulo={articulosBanner[4].id}
                                    imagen={articulosBanner[4].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[5].name}
                                    idArticulo={articulosBanner[5].id}
                                    imagen={articulosBanner[5].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[6].name}
                                    idArticulo={articulosBanner[6].id}
                                    imagen={articulosBanner[6].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[7].name}
                                    idArticulo={articulosBanner[7].id}
                                    imagen={articulosBanner[7].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[8].name}
                                    idArticulo={articulosBanner[8].id}
                                    imagen={articulosBanner[8].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[9].name}
                                    idArticulo={articulosBanner[9].id}
                                    imagen={articulosBanner[9].image}
                                />
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;


/**
 * <div className="banner__articles--detail">
                    <h3>Comparte todo el estilo</h3>
                    <span>Audi en familia</span>

                    <button className="btn-general btn-tertiary-prev v-align-c" onClick={() => verArticulosSlide()}>
                        <svg className="i-rotate" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                        <path id="arrow_right" d="M10.735,16.028,12,17.293l6-6-6-6L10.735,6.558l3.84,3.84H6v1.789h8.576Z" transform="translate(-6 -5.293)" fill="#fff"/>
                        </svg>
                        <span>Volver</span>
                    </button>
                </div>
 */